import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Table,
  Space,
  Button,
  Tag
} from '@lockerpm/design';

import {
  DeleteOutlined,
  SendOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";

import global from "../../../../../config/global";

import {
  convertDateTime,
  wsMemberRole,
  wsMemberStatus
} from '../../../../../utils/common'

const TableData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation()
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace)
  const userInfo = useSelector((state) => state.auth.userInfo);

  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    rowSelection = {},
    mailConfig = null,
    onDelete = () => {},
    onReinvite = () => {}
  } = props;

  const columns = useMemo(() => {
    return [
      {
        title: t('common.no'),
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 80,
      },
      {
        title: t('common.full_name'),
        dataIndex: 'full_name',
        key: 'full_name',
        align: 'left',
        render: (_, record) => <TextCopy
          value={record.user?.full_name}
        />
      },
      {
        title: t('common.email'),
        dataIndex: 'username',
        key: 'username',
        align: 'left',
        render: (_, record) => <TextCopy
          value={record.user?.username}
        />
      },
      {
        title: t('common.role'),
        dataIndex: 'role',
        key: 'role',
        align: 'center',
        width: 120,
        render: (_, record) => {
          const role = wsMemberRole(record.role)
          return <Tag
            color={role?.color}
          >
            <TextCopy
              value={t(role?.label)}
            />
          </Tag>
        }
      },
      {
        title: t('common.status'),
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        width: 120,
        render: (_, record) => {
          const status = wsMemberStatus(record.status)
          return <Tag
            color={status?.color}
          >
            <TextCopy
              value={t(status?.label)}
            />
          </Tag>
        }
      },
      {
        title: t('common.access_date'),
        dataIndex: 'access_date',
        key: 'access_date',
        align: 'center',
        width: 200,
        render: (_, record) => <TextCopy
          value={convertDateTime(record.access_date)}
          align={'center'}
        />
      },
      {
        title: t('button.reinvite'),
        dataIndex: 'reinvite',
        key: 'reinvite',
        align: 'center',
        width: 100,
        hide: !mailConfig,
        render: (_, record) => <Button
          icon={<SendOutlined />}
          disabled={record.status !== global.constants.WS_MEMBER_STATUS.CREATED}
          type={'link'}
          onClick={() => onReinvite(record)}
        />
      },
      {
        title: t('common.actions'),
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        fixed: 'right',
        width: 100,
        render: (_, record) => (
          <Space size={[8, 8]}>
            {
              record.user?.username !== userInfo?.username && <Button
                icon={<DeleteOutlined />}
                type={'link'}
                danger
                onClick={() => onDelete(record)}
              />
            }
          </Space>
        ),
      },
    ].filter((c) => !c.hide)
  }, [selectedWorkspace, userInfo])

  return (
    <Table
      className={className}
      columns={columns}
      dataSource={data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))}
      loading={loading}
      pagination={false}
      rowKey={(record) => record?.id}
      rowSelection={rowSelection}
      size="small"
      sortDirections={['ascend', 'descend']}
      scroll={{ x: 1024 }}
    />
  );
}

export default TableData;
